import Pusher from "pusher-js";
import Echo from "laravel-echo";

const PUSHER = Pusher;
const ECHO = new Echo({
  broadcaster: "pusher",
  key: "a8d47f83958a7bbea359",
  wsHost: process.env.VUE_APP_BASE_URL_SOCKET,
  wsPort: +process.env.VUE_APP_BASE_URL_SOCKET_PORT,
  forceTLS: !!+process.env.VUE_APP_BASE_URL_SOCKET_USE_TLS,
  disableStats: false,
  cluster: "eu"
});
export default {
  PUSHER,
  ECHO
};
